import { render, staticRenderFns } from "./po-Mains.vue?vue&type=template&id=3a4c0cce&scoped=true&"
import script from "./po-Mains.vue?vue&type=script&lang=js&"
export * from "./po-Mains.vue?vue&type=script&lang=js&"
import style0 from "./po-Mains.vue?vue&type=style&index=0&id=3a4c0cce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c0cce",
  null
  
)

export default component.exports